import {Col, Row} from 'antd';
import _ from 'lodash';
import React, {useContext} from 'react';
import {DEMO_COMPANY_MESSAGE} from '../../reducers/settings';
import SettingsContext from '../../reducers/SettingsContext';

// TODO: move this message to the common SupportBar so that it is DRY
const DemoMessage = () => {

    const settingValues = useContext(SettingsContext)

    const message = () => {
        const message = settingValues[DEMO_COMPANY_MESSAGE]
        if (_.isNil(message)) {
            return null
        } else {
            return <Col span={24}>
                <Row className={'main-header'}>
                    <Col span={24}>
                        <div className="warning">
                            {message}
                        </div>
                    </Col>
                </Row>
            </Col>
        }
    }

    return message()
}

export default DemoMessage